
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/faf67f3ebe6a72fc4a40251d40db3ca3.jpg"
          alt="Ultra-High Resolution Mega Yacht Deck Medical Training - U First Doctors Elite Female Instructor Teaching CPR to Three Male Crew Members"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-[900px] mx-auto">
          <div className="text-[8px] sm:text-[9px] md:text-[10px] uppercase tracking-[0.2em] sm:tracking-[0.25em] text-[#A0A0A0] font-light mb-4 sm:mb-6 md:mb-8">
            Elite Medical Security Consultancy Firm
          </div>
          
          <h1 className="text-[32px] sm:text-[48px] md:text-[64px] lg:text-[80px] font-bold leading-[1.1] sm:leading-[1.2] text-[#F5F5F5] mb-6 sm:mb-8 md:mb-12 font-serif">
            U First Doctors
          </h1>
          
          <p className="text-sm sm:text-base md:text-lg lg:text-xl font-light text-[#C0C0C0] leading-relaxed mb-8 sm:mb-10 md:mb-12 px-4 sm:px-0">
            Invest in elite medical knowledge that empowers those around you—delivering readiness, confidence, and medical security wherever life or duty takes you
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4 sm:px-0">
            <button
              onClick={scrollToContact}
              className="w-full sm:w-auto bg-[#1C1410] border border-[#404040] hover:bg-[#2A1F18] hover:border-[#606060] rounded-full px-6 sm:px-8 py-3 sm:py-4 text-[10px] sm:text-[11px] uppercase tracking-[0.15em] text-white transition-all duration-200 flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap"
            >
              Request Consultation and Quotation
              <i className="ri-arrow-right-line text-sm sm:text-base"></i>
            </button>
            
            <button
              onClick={() => {
                const element = document.getElementById('philosophy');
                if (element) {
                  element.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="w-full sm:w-auto border border-[#404040] hover:border-[#606060] rounded-full px-6 sm:px-8 py-3 sm:py-4 text-[10px] sm:text-[11px] uppercase tracking-[0.15em] text-[#F5F5F5] hover:text-white transition-all duration-200 flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap"
            >
              Learn More
              <i className="ri-arrow-down-line text-sm sm:text-base"></i>
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 sm:bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button
          onClick={() => {
            const element = document.getElementById('philosophy');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }}
          className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center border border-[#404040] rounded-full text-[#A0A0A0] hover:text-[#F5F5F5] hover:border-[#606060] transition-all cursor-pointer"
        >
          <i className="ri-arrow-down-line text-sm sm:text-base"></i>
        </button>
      </div>
    </section>
  );
}
